import React from 'react'
import styled from 'styled-components'

const IconPodcastStyle = styled.div`
    cursor: pointer;

    :hover {
        svg g {
            fill: var(--accent-color);
        }
    }
`

const IconPodcast = ({ socialLink }) => (
    <a href={socialLink} target="blank">
        <IconPodcastStyle>
            <svg
                width="38px"
                height="38px"
                viewBox="0 0 38 38"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>icon-podcast</title>
                <desc>Created with Sketch.</desc>
                <g
                    id="icon-podcast"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        d="M21.669668,32.6267383 C21.3683203,33.7406055 20.2299609,34 19.125,34 C18.0200977,34 16.8816797,33.7406055 16.5803906,32.6267383 C16.1324414,30.9609766 15.375,26.7869922 15.375,24.8447266 C15.375,22.7848047 17.1997266,22.28125 19.125,22.28125 C21.0502734,22.28125 22.875,22.7848047 22.875,24.8447266 C22.875,26.775332 22.1208398,30.9489648 21.669668,32.6267383 Z M15.1914258,20.9074609 C14.0961328,19.8347266 13.4360742,18.3191992 13.5048633,16.6536133 C13.6252148,13.7400977 15.9889453,11.3827539 18.9027539,11.2699609 C22.1051953,11.1459766 24.75,13.7152539 24.75,16.890625 C24.75,18.4625195 24.1017188,19.8857031 23.0586328,20.9073438 C22.9018945,21.0608594 22.9179492,21.3166797 23.0954297,21.4456445 C23.6410547,21.8420313 24.0598828,22.3446484 24.3396094,22.9317578 C24.4416211,23.1458594 24.720293,23.2048047 24.8932617,23.0425586 C26.5822852,21.4580078 27.6209766,19.1880859 27.5599219,16.6813281 C27.4512305,12.2161328 23.8336523,8.58320313 19.3689258,8.45658203 C14.6056055,8.32146484 10.6875,12.1571289 10.6875,16.890625 C10.6875,19.3141211 11.7147656,21.5019531 13.3564453,23.0423242 C13.5294727,23.2046875 13.8082617,23.1460352 13.910332,22.9317578 C14.1900586,22.3445898 14.6089453,21.8420313 15.1545703,21.4456445 C15.3320508,21.3167383 15.3481641,21.060918 15.1914258,20.9074609 L15.1914258,20.9074609 Z M19.125,4 C11.8713281,4 6,9.87021484 6,17.125 C6,22.3979688 9.08214844,26.8308789 13.3675195,28.92625 C13.6214062,29.0503516 13.9105078,28.8357813 13.8676172,28.5565234 C13.7280469,27.6476172 13.6132031,26.7432813 13.5508594,25.9585352 C13.5423047,25.850957 13.4835352,25.7542773 13.3939453,25.6941602 C10.6166016,23.8305273 8.79058594,20.6541602 8.81267578,17.0605469 C8.84736328,11.4216602 13.4585742,6.82726563 19.0975781,6.81255859 C24.7964648,6.79767578 29.4375,11.4295117 29.4375,17.125 C29.4375,20.7538281 27.5532422,23.9505859 24.7119141,25.789082 C24.6533789,26.6115625 24.5320898,27.5813477 24.3823828,28.5564648 C24.3394922,28.8357813 24.6286523,29.0503516 24.8824805,28.9261914 C29.157832,26.8355664 32.25,22.4093945 32.25,17.125 C32.25,9.87138672 26.3797852,4 19.125,4 Z M19.125,13.375 C17.0539453,13.375 15.375,15.0539453 15.375,17.125 C15.375,19.1960547 17.0539453,20.875 19.125,20.875 C21.1960547,20.875 22.875,19.1960547 22.875,17.125 C22.875,15.0539453 21.1960547,13.375 19.125,13.375 Z"
                        id="Shape"
                        stroke="#EE0202"
                        fillRule="nonzero"
                    ></path>
                </g>
            </svg>
        </IconPodcastStyle>
    </a>
)

export default IconPodcast
